let osConnection = {};

var generalConnector;

var tc;
var slideshow;
var statePPT = "NoKnown";
var positionPPT = 0;
var notesPPT = null;
let lastPpts = [];

let imagePathTemp;

export default function FlipwitSlideConnectorMac(connectorInstance) {
  generalConnector = connectorInstance;
  return osConnection;
}

//En mac no se conecta a ningun lado (En windows se conecta a powerpoint por sockets) entonces 
//solo inicializa las variables de conexion
osConnection.init = function() 
{
  console.log("Init on mac");
  var SlideShow = require("./api/slideshow-api");
  slideshow = new SlideShow("powerpoint");

  //

  slideshow.getTempPath( osConnection.onTempPath );

  osConnection.callState();
  //setInterval( function(){ osConnection.callState() }, 200);
}

osConnection.onTempPath = function( path ){
  
  imagePathTemp = path;
  /*imagePathTemp = path.replace(new RegExp(":", 'g'), "/");
  if ( imagePathTemp.endsWith("/") ){
    imagePathTemp = imagePathTemp.substring(0, imagePathTemp.length - 1);
  }*/

  console.log("LA variable " + imagePathTemp );
  osConnection.getTempPath();
}

osConnection.getTempPath = function() {
  const remote = window.require('electron').remote;
  var imagePathToglea = remote.app.getPath('desktop');
  
  imagePathToglea =  imagePathToglea.replace( "/Desktop", "/Library/Containers/com.microsoft.Powerpoint");
  
  let fs = window.require('fs');
  if( !fs.existsSync(imagePathToglea )){
    fs.mkdir( imagePathToglea );
  }     

  imagePathToglea = imagePathToglea + "/Data";
  if( !fs.existsSync(imagePathToglea )){
    fs.mkdir( imagePathToglea );
  } 

  console.log("image final " + imagePathToglea);

  return imagePathToglea;//*/

  /*const remote = window.require('electron').remote;
  //
  var imagePathToglea = remote.app.getPath('userData');
  
  return imagePathToglea;//*/

  //return imagePathTemp;
}

osConnection.callState = function( ){
  slideshow.setStateCB( osConnection.stateExecuted, generalConnector.timeScriptWSH ); 
}

osConnection.comparePpts = function( newPpts ){
  if (lastPpts.length != newPpts.length)
        return false;

    for (var i = 0, l=lastPpts.length; i < l; i++) {
        if (lastPpts[i] != newPpts[i]) { 
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;   
        }           
    }       
    return true;
}

osConnection.stateExecuted = function( state ){
  
  if( ! osConnection.comparePpts( state.response.ppts ) ){
    lastPpts = state.response.ppts;
    generalConnector.pptsOpen(state.response.ppts);  
  }
  
  osConnection.setStatePPT( state.response.state );
  //osConnection.setStatePPT( "viewing" );

  if( statePPT == "viewing" ){
    generalConnector.setSlidePosition(state.response.position,true);
  }

  //----------------------------------FALTA LO DEL ESTADO DE VIEWING Y ESO
  /*osConnection.setPositionSlide( state.response.position );
    */
}

//posibles estados: viewing, editing, closed, done
osConnection.setStatePPT = function( state ){
  if( statePPT != state ){
    console.log("estado: " + state);
    let lastState = statePPT;
    statePPT = state;

    switch( statePPT ){
      case "viewing": 
            console.log("paso a viewing " + lastState)
            if( lastState == "editing" ){
              osConnection.getNotes( );        
            }
            break;

      case "closed":
              generalConnector.hideTogleaWindow();
              generalConnector.pptsOpen([]);
        break;

      case "done":
              generalConnector.slideShowDone();
              generalConnector.hideTogleaWindow();
        break;

      case "editing":
              if( lastState == "viewing" || lastState == "done"){
                osConnection.setImagesVisible();
                generalConnector.slideShowEnds();
              }
        break;
    }
    
  } 
}

osConnection.setImagesVisible = function( ){
  slideshow.visibleImgs();
}

osConnection.getNotes = function( ){
  slideshow.info( osConnection.infoExecuted );
}

osConnection.infoExecuted = function( data ){
  console.log("data of info: " , data)

  generalConnector.setElectronSession();
  let previewsPath = data.response.previewsPath.replace(new RegExp(":", 'g'), "/");
  if( !previewsPath.startsWith("/")){
    previewsPath = previewsPath.substring( previewsPath.indexOf("/") );
  }

  generalConnector.setResolutionData( data.response.resX, data.response.resY, data.response.resW, data.response.resH)
  generalConnector.setPreviewsPath( previewsPath);
  generalConnector.setSlidesImages(data.response.images); 
  generalConnector.setPPTName(data.response.name);
  generalConnector.setSlidesNotes(data.response.notes);  
  generalConnector.verifyPreviews();  
  
}

osConnection.getImageToglea = function( ){
  //require("electron").remote.app.getWindow().focus();
  slideshow.imgToglea( osConnection.onImageToglea );
}

osConnection.onImageToglea = function( data ){
  generalConnector.setTogleaSlide( data.response.name, data.response.x, data.response.y, data.response.width, data.response.height, data.response.wslide, data.response.hslide, data.response.resX, data.response.resY, data.response.resW, data.response.resH );  
}

osConnection.activatePP = function(){
  slideshow.activate();
}

osConnection.finishSlideshow = function() {  
  slideshow.stop();
} 

osConnection.startSlideshow = function( pptName ) {
  const remote = window.require('electron').remote;
  let countScreens = remote.app.getCountScreens();
  console.log("cantidad des creens " + countScreens);

  if( statePPT == "viewing" || statePPT == "done"){
    osConnection.getNotes();
  }
  else{
    slideshow.start( encodeURIComponent(pptName), countScreens );//as("applescripts/runPresentation")
  }     
} 

osConnection.goNextSlide = function() {
  var res = slideshow.next();//as("applescripts/nextSlide")
}

osConnection.goPrevSlide = function() {
  slideshow.prev();
}

osConnection.insertSlide = function( path, idImage, width, height, pptName, comment){
  console.log("Insert a slide with comment " + comment)
  var tmpSlipt = imagePathTemp.split(":");

  if(  ! path.startsWith( tmpSlipt[0] ) ){
    path = tmpSlipt[0] + path;
  }

  path = path.replace(new RegExp("/", 'g'), ":");

  console.log("el path " + path + " --- " + imagePathTemp)
  slideshow.insertSlide( encodeURIComponent(path), idImage, width, height, encodeURIComponent(pptName), encodeURIComponent(comment) );
}

osConnection.getPptsOpen = function(){
  //the ppts are got from the interval that looks the state
  generalConnector.pptsOpen( lastPpts );
}

osConnection.exportSlides = function(namePPT){
  slideshow.exportToPDF( encodeURIComponent(namePPT), this.onSlidesExported );
}

osConnection.onSlidesExported = function( resp ){
  const objExported = {
    cmd: "EXPORT",
    response: resp.response
  };
  generalConnector.onSlidesExported( objExported );
  generalConnector.onSlidesExported( resp );
}

//var obj = {'command':'InteractionFeature', 'interactionType':'Init'};




// WEBPACK FOOTER //
// ./src/containers/platforms/electron/js/powerpoint/mac/FlipwitSlideConnectorMac.js